<template>
  <div id="home" v-loading.fullscreen.lock="changeLoading">
    <div style="background-color: white; margin: 1rem 2rem">
      <div class="pos_container_panel">
        <el-form :inline="true" style="padding-top: 1rem">
          <el-row style="">
            <el-col :span="12">
              <el-form-item label="客户名称">
                <el-input
                  v-model="searchForm.customerName"
                  @click="showClientNamePop"
                  class="searchInput"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="客户编码">
                <el-input
                  v-model="searchForm.customerCode"
                  class="searchInput"
                ></el-input> </el-form-item
            ></el-col>
          </el-row>
          <el-row style="">
            <el-col :span="12"
              ><div class="grid-content bg-purple">
                <el-form-item label="活动状态">
                  <el-select
                    v-model="searchForm.activiteStatus"
                    class="searchInput"
                  >
                    <el-option
                      v-for="item in bannertypeoptions"
                      :key="item.key"
                      :label="item.value"
                      :value="item.key"
                    ></el-option>
                  </el-select>
                </el-form-item></div
            ></el-col>
            <el-col :span="12"
              ><div class="grid-content bg-purple-light">
                <el-form-item label="活动名称">
                  <el-input
                    v-model="searchForm.activiteName"
                    class="searchInput"
                  ></el-input>
                </el-form-item></div
            ></el-col>
          </el-row>
          <el-row style="">
            <el-col :span="12"
              ><div class="grid-content bg-purple">
                <el-form-item label="活动编码">
                  <el-input
                    v-model="searchForm.activiteCode"
                    class="searchInput"
                  ></el-input>
                </el-form-item></div
            ></el-col>
            <el-col :span="12" style="float: right"
              ><div class="grid-content bg-purple-light" style="float: right">
                <el-button
                  type="warning"
                  class="harpIDbtn"
                  @click="SearchAdsList(1)"
                >
                  搜索</el-button
                >
                <el-button
                  type="warning"
                  class="harpIDbtn"
                  style="margin-left: 3rem"
                  @click="AddPos"
                >
                  新增客户
                </el-button>
              </div></el-col
            >
          </el-row>
        </el-form>
        <hr
          style="
            margin: 1rem -14rem 0rem;
            background-color: rgb(241 243 245);
            height: 0.2rem;
            border: none;
          "
        />
        <!--table-->
        <el-table
          :data="tableData"
          border
          style="width: 100%; margin-top: 50px"
          @cell-click="CellClick"
          :cell-style="tableCellStyle"
        >
          <el-table-column
            prop="customerCode"
            label="编码"
            align="center"
          ></el-table-column>
          <el-table-column
            prop="customerName"
            label="客户名称"
            align="center"
          ></el-table-column>
          <el-table-column
            prop="isReceive"
            label="是否显示广告"
            align="center"
          ></el-table-column>
          <el-table-column
            prop="home"
            label="首页"
            align="center"
          ></el-table-column>
          <el-table-column
            prop="domesticTickets"
            label="国内机票"
            align="center"
          ></el-table-column>
          <el-table-column
            prop="internationalTickets"
            label="国际机票"
            align="center"
          ></el-table-column>
          <el-table-column
            prop="domesticHotel"
            label="国内酒店"
            align="center"
          ></el-table-column>
          <el-table-column
            prop="internationalHotel"
            label="国际酒店"
            align="center"
          ></el-table-column>
          <el-table-column
            prop="train"
            label="火车"
            align="center"
          ></el-table-column>
          <el-table-column
            prop="itinerary"
            label="行程单"
            align="center"
          ></el-table-column>
          <el-table-column
            prop="crm"
            label="CRM"
            align="center"
          ></el-table-column>
          <el-table-column label="操作" width="132" align="center">
            <template #default="scope">
              <el-button
                type="text"
                size="small"
                @click.prevent="deleteRow(scope.row)"
                >删除
              </el-button>
            </template>
          </el-table-column>
        </el-table>
        <div style="margin-bottom: 1rem">
          <el-pagination
            class="paginationsty"
            background
            @current-change="handleCurrentChange"
            :current-page="searchForm.pagination.currentPage"
            :page-size="searchForm.pagination.pageSize"
            layout="total, prev, pager, next"
            :total="searchForm.pagination.total"
          >
          </el-pagination>
        </div>
      </div>
    </div>
    <!--修改 是否接受 dialog-->
    <el-dialog
      title="修改-是否显示广告"
      v-model="ReceiveEdit.isShow"
    >
      <el-form :model="ReceiveEdit" ref="checkReceiveEdit">
        <el-form-item label="客户编号:" :label-width="formLabelWidth">
          <el-input
            disabled
            v-model="ReceiveEdit.customerCode"
            autocomplete="off"
            style="width: 58%; margin-left: 85px"
          ></el-input>
        </el-form-item>
        <el-form-item label="客户名称:" :label-width="formLabelWidth">
          <el-input
            disabled
            v-model="ReceiveEdit.customerName"
            autocomplete="off"
            style="width: 58%; margin-left: 85px"
          ></el-input>
        </el-form-item>
        <el-form-item label="是否接受:" :label-width="formLabelWidth">
          <el-select
            style="width: 58%; margin-left: 85px"
            v-model="ReceiveEdit.isReceive"
            placeholder="请选择"
          >
            <el-option
              v-for="item in ReceiveList"
              :key="item.value"
              :label="item.name"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <template #footer>
        <div class="dialog-footer">
          <el-button type="primary" @click="ReceiveChangeSave()">保存</el-button>
          <el-button @click="ReceiveCancel()">取 消</el-button>
        </div>
      </template>
    </el-dialog>
    <!--修改 活动绑定 dialog-->
    <el-dialog
      :title="ActivityEdit.title"
      v-model="ActivityEdit.isShow"
    >
      <el-form :model="ActivityEdit" ref="checkActivityEdit">
        <el-form-item label="客户编号:" :label-width="formLabelWidth">
          <el-input
            disabled
            v-model="ActivityEdit.customerCode"
            autocomplete="off"
            style="width: 58%; margin-left: 85px"
          ></el-input>
        </el-form-item>
        <el-form-item label="客户名称:" :label-width="formLabelWidth">
          <el-input
            disabled
            v-model="ActivityEdit.customerName"
            autocomplete="off"
            style="width: 58%; margin-left: 85px"
          ></el-input>
        </el-form-item>
        <el-form-item label="绑定活动:" :label-width="formLabelWidth">
          <el-checkbox-group
            v-model="ActivityEdit.activityBindList"
            style="margin-left: 85px"
          >
            <el-checkbox
              v-for="item in ActivityEdit.activityList"
              :label="item"
              :key="item.id"
              >{{ item.name }}</el-checkbox
            >
          </el-checkbox-group>
          <!-- <el-input
            v-model="ReceiveEdit.isReceive"
            autocomplete="off"
            style="width: 58%; margin-left: 85px"
          ></el-input> -->
          <!-- <el-select
            style="width: 58%; margin-left: 85px"
            v-model="ActivityEdit.isReceive"
            placeholder="请选择"
          >
            <el-option
              v-for="item in ReceiveList"
              :key="item.value"
              :label="item.name"
              :value="item.value"
            >
            </el-option>
          </el-select> -->
        </el-form-item>
      </el-form>
      <template #footer>
        <div class="dialog-footer">
          <el-button type="primary" @click="ActivityChangeSave()">保存</el-button>
          <el-button @click="ActivityCancel()">取 消</el-button>
        </div>
      </template>
    </el-dialog>
    <!--删除 客户 dialog-->
    <el-dialog
      title="警告"
      v-model="dialogVisible"
      width="30%"
    >
      <span>{{
        this.delMappingMsg !== ""
          ? this.delMappingMsg
          : "将删除该客户所有配置信息，请确认是否删除"
      }}</span>
      <template #footer>
        <span class="dialog-footer">
          <el-button type="primary" @click="confirmDelete">确 定</el-button>
          <el-button @click="cancelDelete">取 消</el-button>
        </span>
      </template>
    </el-dialog>
    <ConfirmBoxs
      :centerDialogVisible="confirmFlag"
      :confirmMsg="confirmMsg"
      :icon="confirmIcon"
      @setConfirmFlag="setConfirmFlag"
    ></ConfirmBoxs>
    <ClientList :customerDialogVisible = "clientListFlag" @setCustomerFlag = "setCustomerFlag" @customerInfo = "selectClient"></ClientList>
  </div>
</template>
<script>
import {
  getAdsList,
  updateisreceive,
  getActivityList,
  saveAdvertiseDetail,
  AdsDelete,
  addCusconfig,
} from "@/api/platformData";
import ConfirmBoxs from "@/components/confirmBoxs.vue";
import ClientList from "@/components/ClientList.vue";
export default {
  name: "BannerBind",
  components: {
    ConfirmBoxs,
    ClientList,
  },
  data() {
    return {
      clientListFlag: false,
      confirmFlag: false,
      confirmMsg: "",
      confirmIcon: "",
      formLabelWidth: "15rem",
      currentPage1: 1,
      searchForm: {
        total: 1,
        customerName: "", //客户名称
        customerCode: "", //客户编码
        activiteStatus: "", //活动状态
        activiteName: "", //活动名称
        activiteCode: "", //活动编码
        pagination: {
          total: 0, //总数
          pageSize: 15,
          currentPage: 1,
        }, //分页信息
      },
      hotelCustomerCode: "", //选中的客户编号
      //活动状态
      bannertypeoptions: [
        { key: 0, value: "未开始" },
        { key: 1, value: "生效中" },
        { key: 2, value: "已结束" },
      ],
      //pageType
      pageTypeoptions: [
        { key: 0, value: "首页" },
        { key: 1, value: "国内机票" },
        { key: 2, value: "国际机票" },
        { key: 3, value: "国内酒店" },
        { key: 4, value: "国际酒店" },
        { key: 5, value: "火车" },
        { key: 6, value: "行程单" },
        { key: 7, value: "CRM" },
        { key: 8, value: "通用" },
      ],
      tableData: [
        // {
        //   customerCode: "yg00001",
        //   customerName: "测试企业",
        //   isReceive: "否", //是否接受
        //   home: "0", //首页
        //   domesticTickets: "0", //国内机票
        //   internationalTickets: "0", //国际机票
        //   domesticHotel: "0", //国内酒店
        //   internationalHotel: "0", //国际酒店
        //   train: "0", //火车
        //   itinerary: "0", //行程单
        //   crm: "0", //crm
        // },
      ],
      //是否接受弹框修改
      ReceiveEdit: {
        customerCode: "",
        customerName: "",
        isReceive: true, //是否接受
        isShow: false, //是否显示
      },
      ReceiveList: [
        { value: false, name: "是" },
        { value: true, name: "否" },
      ],
      //活动绑定弹框
      ActivityEdit: {
        customerCode: "",
        customerName: "",
        type: 0, //类型
        isShow: false, //是否显示
        title: "",
        activityList: [],
        activityBindList: [],
      },
      isPosAdd: true, //是否客户新增
      dialogVisible: false,
      changeLoading: false,
      delMappingMsg: "",
      deleteparams: {
        customerCode: "",
      },
    };
  },
  mounted() {},
  methods: {
    //confirm
    setConfirmFlag(value) {
      this.confirmFlag = value;
    },
    //分页
    handleCurrentChange(currPage) {
      this.SearchAdsList(currPage);
    },
    //搜索点击客户名称弹出选择客户
    showClientNamePop() {
      this.isPosAdd = false;
      this.clientListFlag = true;
    },
    //弹出客户姓名窗口方法
    AddPos() {
      this.isPosAdd = true;
      this.clientListFlag = true;
    },
    //选择客户
    selectClient(item) {
      if (this.isPosAdd) {
        this.hotelCustomerCode = item.customerCode;
        let customerCode = item.customerCode;
        let customerName = item.customerName;
        this.confirmAdd(customerCode, customerName);
      } else {
        this.searchForm.customerName = item.customerName;
        this.searchForm.customerCode = item.customerCode;
      }
    },
   tableCellStyle({row, column, rowIndex, columnIndex}) {
      const style = {cursor: 'pointer'}
      if(columnIndex >= 3 && columnIndex <= 10 && row.isReceive != "是") {
        style.background = 'rgb(241 241 241)'
      }
      return style
    },
    //单元格点击触发事件
    CellClick(row, column) {
      if (column.property == "isReceive") {
        //是否接受
        this.Receive(row.customerCode, row.customerName, row.isReceive);
      }
      if(row.isReceive!="是")
      {
        return;
      }
      if (column.property == "home") {
        //首页绑定
        let type = 0;
        let title = "首页活动绑定";
        this.ActivityBind(row.customerCode, row.customerName, type, title);
      }
      if (column.property == "domesticTickets") {
        //国内机票
        let type = 1;
        let title = "国内机票活动绑定";
        this.ActivityBind(row.customerCode, row.customerName, type, title);
      }
      if (column.property == "internationalTickets") {
        //国际机票
        let type = 2;
        let title = "国际机票活动绑定";
        this.ActivityBind(row.customerCode, row.customerName, type, title);
      }
      if (column.property == "domesticHotel") {
        //国内酒店
        let type = 3;
        let title = "国内酒店活动绑定";
        this.ActivityBind(row.customerCode, row.customerName, type, title);
      }
      if (column.property == "internationalHotel") {
        //国际酒店
        let type = 4;
        let title = "国际酒店活动绑定";
        this.ActivityBind(row.customerCode, row.customerName, type, title);
      }
      if (column.property == "train") {
        //火车
        let type = 5;
        let title = "火车活动绑定";
        this.ActivityBind(row.customerCode, row.customerName, type, title);
      }
      if (column.property == "itinerary") {
        //行程单
        let type = 6;
        let title = "行程单活动绑定";
        this.ActivityBind(row.customerCode, row.customerName, type, title);
      }
      if (column.property == "crm") {
        //crm
        let type = 7;
        let title = "CRM活动绑定";
        this.ActivityBind(row.customerCode, row.customerName, type, title);
      }
    },
    //是否接受修改
    Receive(customerCode, customerName, isReceive) {
      this.ReceiveEdit.isShow = true;
      this.ReceiveEdit.customerCode = customerCode;
      this.ReceiveEdit.customerName = customerName;
      this.ReceiveEdit.isReceive = isReceive == "是" ? false : true;
    },
    //是否接受保存
    ReceiveChangeSave() {
      this.changeLoading = true;
      let Param = [
        {
          CustomerCode: this.ReceiveEdit.customerCode,
          IsReceive: this.ReceiveEdit.isReceive,
        },
      ];
      updateisreceive(Param)
        .then((res) => {
          if (res.code === 200) {
            this.changeLoading = false;
            this.confirmFlag = true;
            this.confirmMsg = "修改成功";
            this.handleCurrentChange(this.searchForm.pagination.currentPage);
          } else {
            this.changeLoading = false;
            this.confirmFlag = true;
            this.confirmMsg = "修改失败";
          }
        })
        .catch(() => {
          this.changeLoading = false;
          this.confirmFlag = true;
          this.confirmMsg = "修改失败";
        });
      this.ReceiveEdit.isShow = false;
    },
    //是否接受弹框取消
    ReceiveCancel() {
      this.ReceiveEdit.isShow = false;
    },
    //活动绑定
    ActivityBind(customerCode, customerName, type, title) {
      this.ActivityEdit.title = title;
      this.ActivityEdit.type = type;
      this.ActivityEdit.customerCode = customerCode;
      this.ActivityEdit.customerName = customerName;
      this.getActivityTypeList(
        this.ActivityEdit.type,
        this.ActivityEdit.customerCode
      );
    },
    //根据位置获取投放详情
    async getActivityTypeList(type, customerCode) {
      let Param = {
        params: {
          CustomerCode: customerCode,
          PageType: type,
        },
      };
      let that = this;
      await getActivityList(Param)
        .then((res) => {
          console.log("广告投放页列表", res.data);
          if (res.code == 200) {
            that.ActivityEdit.activityList = [];
            that.ActivityEdit.activityBindList = [];
            for (let i = 0; i < res.data.list.length; i++) {
              let item = res.data.list[i];
              let model = {
                name: item.activiteName,
                advertiseID: item.advertiseID,
                isBind: true,
              };
              if (item.bindAdvertiseID > 0) {
                that.ActivityEdit.activityBindList.push(model);
              }
              that.ActivityEdit.activityList.push(model);
            }
            that.ActivityEdit.isShow = true;
          } else {
            that.confirmFlag = true;
            that.confirmMsg = "查询失败,请重新尝试";
            return;
          }
        })
        .catch(function (error) {
          console.log("广告投放页列表 请求失败", error.objError);
        });
    },
    //活动绑定保存
    async ActivityChangeSave() {
      let advertiseIds = [];
      if (this.ActivityEdit.activityBindList.length > 0) {
        advertiseIds = this.ActivityEdit.activityBindList.map((item) => {
          return item.advertiseID;
        });
      }
      let Param = {
        CustomerCode: this.ActivityEdit.customerCode,
        PageType: this.ActivityEdit.type,
        AdvertiseIds: advertiseIds,
      };
      let that = this;
      await saveAdvertiseDetail(Param)
        .then((res) => {
          if (res.code === 200) {
            this.confirmFlag = true;
            this.confirmMsg = "修改成功";
            this.handleCurrentChange(this.searchForm.pagination.currentPage);
          } else {
            this.confirmFlag = true;
            this.confirmMsg = "修改失败";
          }
        })
        .catch(() => {
          this.confirmFlag = true;
          this.confirmMsg = "修改失败";
        });
      that.ActivityEdit.isShow = false;
    },
    //是否接受弹框取消
    ActivityCancel() {
      this.ActivityEdit.isShow = false;
    },
    async SearchAdsList(currPage) {
      let Param = {
        ActiviteCode: this.searchForm.activiteCode,
        ActiviteName: this.searchForm.activiteName,
        ActiviteStatus: this.searchForm.activiteStatus,
        CustomerCode: this.searchForm.customerCode,
        CustomerName: this.searchForm.customerName,
        PageRequest: {
          pageNum: currPage,
          PageLimit: this.searchForm.pagination.pageSize,
          Total: 0,
        },
      };
      let that = this;
      await getAdsList(Param)
        .then((res) => {
          console.log("广告投放页列表", res.data);
          if (res.code == 200) {
            that.tableData = [];
            let adsInfos = res.data.adsInfos;
            for (let i = 0; i < adsInfos.length; i++) {
              let model = {};
              model.customerCode =
                adsInfos[i].activityCustomerConfigs.customerCode;
              model.customerName =
                adsInfos[i].activityCustomerConfigs.customerName;
              model.isReceive = adsInfos[i].activityCustomerConfigs.isReceive
                ? "否"
                : "是";

              //首页绑定数量查询
              model.home = adsInfos[i].advertiseDetails.filter(
                (element) => element.pageType == 0
              ).length;

              //国内机票绑定数量查询
              model.domesticTickets = adsInfos[i].advertiseDetails.filter(
                (element) => element.pageType == 1
              ).length;

              //国际机票绑定数量查询
              model.internationalTickets = adsInfos[i].advertiseDetails.filter(
                (element) => element.pageType == 2
              ).length;

              //国内酒店绑定数量查询
              model.domesticHotel = adsInfos[i].advertiseDetails.filter(
                (element) => element.pageType == 3
              ).length;

              //国际酒店绑定数量查询
              model.internationalHotel = adsInfos[i].advertiseDetails.filter(
                (element) => element.pageType == 4
              ).length;

              //火车绑定数量查询
              model.train = adsInfos[i].advertiseDetails.filter(
                (element) => element.pageType == 5
              ).length;

              //行程单绑定数量查询
              model.itinerary = adsInfos[i].advertiseDetails.filter(
                (element) => element.pageType == 6
              ).length;

              //crm绑定数量查询
              model.crm = adsInfos[i].advertiseDetails.filter(
                (element) => element.pageType == 7
              ).length;

              that.tableData.push(model);
            }
            that.searchForm.pagination.total =
              res.data.adsListReqInfo.pageRequest.total; //总数
          } else {
            that.confirmFlag = true;
            that.confirmMsg = "查询失败,请重新尝试";
            return;
          }
        })
        .catch(function (error) {
          console.log("广告投放页列表 请求失败", error.objError);
        });
    },
    //删除
    async deleteRow(row) {
      this.deleteparams.customerCode = row.customerCode;
      this.dialogVisible = true;
    },
    cancelDelete() {
      this.dialogVisible = false;
    },
    confirmDelete() {
      this.dialogVisible = false;
      let Param = [{
        CustomerCode: this.deleteparams.customerCode,
      }];
      AdsDelete(Param)
        .then((res) => {
          if (res.code === 200) {
            this.changeLoading = false;
            this.confirmFlag = true;
            this.confirmMsg = "删除成功";
            this.deleteFlag = false;
            this.handleCurrentChange(this.searchForm.pagination.currentPage);
          } else {
            this.changeLoading = false;
            this.confirmFlag = true;
            this.confirmMsg = "删除失败";
            this.deleteFlag = false;
          }
        })
        .catch(() => {
          this.changeLoading = false;
          this.confirmFlag = true;
          this.confirmMsg = "删除失败";
          this.deleteFlag = false;
        });
    },
    //新增客户配置
    confirmAdd(customerCode, customerName) {
      this.dialogVisible = false;
      let Param = {
        CustomerCode: customerCode,
        CustomerName: customerName,
      };
      addCusconfig(Param)
        .then((res) => {
          if (res.code === 200) {
            this.changeLoading = false;
            this.confirmFlag = true;
            this.confirmMsg = "添加成功";
            this.deleteFlag = false;
            this.handleCurrentChange(this.searchForm.pagination.currentPage);
          } else {
            this.changeLoading = false;
            this.confirmFlag = true;
            this.confirmMsg = "添加失败:" + res.message;
          }
        })
        .catch(() => {
          this.changeLoading = false;
          this.confirmFlag = true;
          this.confirmMsg = "添加失败";
        });
    },
    setCustomerFlag(value) {
      this.clientListFlag = value;
    },
  },
};
</script>
<style scoped>
.paginationsty {
  float: right;
  margin: 1rem 0;
}
.pos_container_panel {
  padding: 0px 8rem 4rem;
  overflow-x: hidden;
}
.harpIDbtn {
  width: 10rem;
  height: 3rem;
  padding: 0 !important;
  font-size: 1rem !important;
}
.searchInput {
  width: 350px;
  height: 32px;
}

:deep(.el-input__inner) {
  height: 32px;
  line-height: 32px;
}

.el-table .diaabledrow {
  background: #f0f9eb;
}
</style>
  